var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-course-details"},[(_vm.isLoading)?_c('app-loading',{attrs:{"isFull":true}}):_vm._e(),_vm._v(" "),_c('app-course-details',{attrs:{"item":_vm.courseDetail,"goals":_vm.goals,"message":_vm.message,"listCourse":_vm.listCourse},on:{"startEnroll":_vm.startEnroll}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-300e4df0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses.vue
// module id = null
// module chunks = 